import {
  call, put, takeLatest,
} from 'redux-saga/effects';

import { getSabrePnrPrintoutRequest, getSabrePnrPrintoutResponse } from '../../slices/trip';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* getSabrePnrPrintoutWorker({
  payload: {
    recordLocator,
    doIncludeSeats,
  },
}) {
  try {
    const config = {
      method: 'get',
      url: `trips/getPnrPrintout?${queryString.stringify({
        PNR: recordLocator,
        doIncludeSeats,
      }, { skipNull: true })}`,
    };
    const response = yield call(axios, config);
    if (response.data) {
      yield put(getSabrePnrPrintoutResponse({ data: response.data }));
    } else throw new Error();
  } catch (error) {
    yield put(getSabrePnrPrintoutResponse());
  }
}

function* runSabreCommandWatcher() {
  yield takeLatest(getSabrePnrPrintoutRequest.toString(), getSabrePnrPrintoutWorker);
}

export default runSabreCommandWatcher;
